import { useContext } from 'react'

import { EngagementContext } from 'modules/engagement/lib/EngagementContext'

export const useEngagementContext = () => {
  const context = useContext(EngagementContext)

  if (!context) {
    throw new Error('EngagementContext must be within its provider')
  }

  return context
}
